var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close_circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#11232e"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 9,
    cy: 9,
    r: 8.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1262.328 -191.5)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#11232e",
    x2: 6,
    y2: 6,
    transform: "translate(1268.328 197.5)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#11232e",
    x1: 6,
    y2: 6,
    transform: "translate(1268.328 197.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close_circle.e00b61840c73e2ec812480bbbe157672.svg";
export { ForwardRef as ReactComponent };